import {AggregationSelector} from "./aggregation-selector";
import {ColumnSelector} from "./column-selector";

export class StocksPreset{
    constructor(
        public presetGuidName: string, public data: StocksPresetData[]
    ){

    }
}

export class StocksPresetData{
    constructor(
        public presetName: string, public shortPresetName: string, public description: string, public counter: number
    ){
        this.hotKey = 100;
        this.uses = 0;
        this.gridProps = [];
        this.gridProps.push(new GridProps('views'));
        this.gridProps.push(new GridProps('parameters'));
        //this.gridProps.push(new GridProps('hidden'));
        this.groups = [];
        this.aggregations = [];
        this.sorting = {columnId: '', asc: true};
        this.tabsPositionClass = '';
        this.freezeColumns = 2;

    }
    // public presetName: string;
    // public shortPresetName: string;
    public hotKey: number;
    public freezeColumns: number;
    public uses: number;
    public gridProps: GridProps[];
    public groups: ColumnSelector[];
    public aggregations: AggregationSelector[];
    public sorting: {columnId: string, asc: boolean};
    public tabsPositionClass: string;

    //public description: string
}

export class GridProps{
    constructor(
        public tableName: string
    ){
        this.gridColumns = [];
        // this.gridColumns.push({id: 'someId2', width: 200});
        // this.gridColumns.push({id: 'someId', width: 100});
    }

    public gridColumns: Slick.Column<any>[];
}


export class SlickPreset{
    constructor(
        public readonly id: number, public readonly name, public readonly hokey, public readonly guidName
    ){
    }
}





// WEBPACK FOOTER //
// ./src/app/stocks/models/stocks-preset.ts